import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  defaultTestDataList:
    JSON.parse(localStorage.getItem("defaultTestDataList")) || [],
};

const proceedWithTestDataSlice = createSlice({
  name: "selectedTestDataList",
  initialState,
  reducers: {
    updateTestQuantity: (state, action) => {
      const { index, quantity, remove } = action.payload;

      if (remove) {
        state.defaultTestDataList.splice(index, 1);
      } else if (quantity !== undefined) {
        state.defaultTestDataList[index].quantity = quantity;
      }

      // Sync with localStorage
      localStorage.setItem(
        "defaultTestDataList",
        JSON.stringify(state.defaultTestDataList)
      );
    },

    setDefaultTestDataList: (state, action) => {
      state.defaultTestDataList = action.payload;

      // Sync with localStorage
      localStorage.setItem(
        "defaultTestDataList",
        JSON.stringify(state.defaultTestDataList)
      );
    },
  },
});

export const { updateTestQuantity, setDefaultTestDataList } =
  proceedWithTestDataSlice.actions;

export default proceedWithTestDataSlice.reducer;
